export const LIMIT = 15;
export const CONFIG = {
    open: true,
    title: 'Error',
    message: 'Please try again with valid dates'
  };